/**
 * Dice rolling rules - derived from glossary metadata.
 * See: STAT_CHECKS_GLOSSARY_UNLISTED.md for Hit, Fumble, Critical Fumble definitions.
 */
import { GLOSSARY } from '~/generated/glossary.data';

const hitEntry = GLOSSARY['Hit'];
const critFumbleEntry = GLOSSARY['Critical Fumble'];

export const ROLL_RULES = {
  hitThreshold: parseInt(hitEntry.metadata.hitThreshold, 10),
  dieType: parseInt(hitEntry?.metadata.dieType, 10),
  critFumbleThreshold: parseFloat(critFumbleEntry?.metadata.critFumbleThreshold),
} as const;

export const isHit = (roll: number): boolean => roll >= ROLL_RULES.hitThreshold;

export const isCritFumble = (ones: number, poolSize: number): boolean =>
  poolSize > 0 && ones >= poolSize * ROLL_RULES.critFumbleThreshold;

export const isFumble = (hits: number, poolSize: number): boolean =>
  poolSize > 0 && hits === 0;
